define('viewmodels/Weightings_Thresholds/PCSThresholds',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system'], function (ko, router, appsecurity, navigation, app, logger, system) {
    var title = 'RiskLevel';

    var PCSViewModel = {
        title: title,
        attached: attached,
        detached: detached,
        appsecurity: appsecurity,
        AssessmentType: ko.observable("AML"),
        RiskAreaListTh: ko.observableArray(),
        RiskAreaTabClickTh: RiskAreaTabClickTh,
        OverallTabClick: OverallTabClick,
        RiskFactorTabClickTh: RiskFactorTabClickTh,
        RiskFactorListTh: ko.observableArray(),
        ClickedRiskAreaId: ko.observable(),
        ClickedRiskAreaType: ko.observable(),
        ClickedRiskAreaName: ko.observable(),
        ClickedRiskFactorId: ko.observable(),
        ClickedRiskFactorName: ko.observable(),
        ClickedRAType: ko.observable(),
        ThresholdValuesList: ko.observableArray(),
        ThresholdValuesListDup: ko.observableArray(),
        ThresholdChildList: ko.observableArray(),
        SelectedAssessmentId: ko.observable(),
        SelectedSurveyComponentIdTh: ko.observable(),
        ThresholdCellBlur: ThresholdCellBlur,
        ResetThresholdData: ResetThresholdData,
        SaveThresholdBtnClick: SaveThresholdBtnClick,
        GreyOutCells: GreyOutCells,
        SaveQualitativeThresholdValues: SaveQualitativeThresholdValues,
        ResetQualitativeThresholdValues: ResetQualitativeThresholdValues,
        countEntry: ko.observable(0),
        ErrorStatus: ko.observable(0),
        PrevRAId: ko.observable(),
        QualThresholdValuesList: ko.observableArray(),
        QualThresholdValuesListDup: ko.observableArray([]),
        OverallThresholdValuesList: ko.observableArray([]),
        OverallThresholdValuesListDup: ko.observableArray([]),
        FactorCountEntry: ko.observable(0),
        PrevFactorId: ko.observable(),
        onBlurMin: onBlurMin,
        InputChange: InputChange,
        InputChangeEvent: ko.observable(false),
        SaveButtonClick: ko.observable(false),
        onBlurEvent: onBlurEvent,
        onKeyPressvalidateNumber: onKeyPressvalidateNumber,
        AssessmentTypeList: ko.observable(),
        SelectedAssessmentType: ko.observable(),
        ScreenName: ko.observable(),
        AssessmentTypeId: ko.observable(),
        SurveyCategoryListTh: ko.observableArray([]),
        SurveyCategoryTabClickTh: SurveyCategoryTabClickTh,
        ComposeBindingFlag: ko.observable(false),
        invokepage: invokepage,
        AreaLeveljstree: ko.observableArray([]),
        ToggleNavigationMenu1: ToggleNavigationMenu1,
        ToggleNavigationMenu2: ToggleNavigationMenu2,
        CollapseAllTreeView: CollapseAllTreeView,
        ExpandAllTreeView: ExpandAllTreeView,
        SearchTreeView: SearchTreeView,
        selectedTreeNode: ko.observableArray([]),
        SurveyTypeClicked: ko.observable(),
        SelectedSurveyComponentId: ko.observable(),
        Type: ko.observable(),
        AreaType: ko.observable(),
        RiskFactorFlagQual: ko.observable(true),
        HeatmapFlag: ko.observable(false),
        copyToAll: copyToAll,
        ControlsAccess: ko.observable(false),
        copyToAllFlag: ko.observable(0),
        RA_Type: ko.observable(),
        hasChildNodes: ko.observable(false)
        //PopulateWeights: PopulateWeights
    };

    return PCSViewModel;

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {

            var Id = PCSViewModel.appsecurity.getParameterByName('atype');
            PCSViewModel.AssessmentTypeId(Id);
            PCSViewModel.appsecurity.GetAssessmentNames().then(function () {
                PCSViewModel.AssessmentType(PCSViewModel.appsecurity.GetAssessmentName(PCSViewModel.AssessmentTypeId()))
                PCSViewModel.ScreenName(PCSViewModel.AssessmentType() + '  PCS Risk Thresholds');
            });
            PCSViewModel.SelectedAssessmentId(Id);
            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        PCSViewModel.ControlsAccess(true);
                    }
                    else {
                        PCSViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                PCSViewModel.ControlsAccess(true);
            }
            else {
                PCSViewModel.ControlsAccess(false);
            }
            //PCSViewModel.appsecurity.GetCurrentYearOfAssessment().then(function () {
            //    PCSViewModel.appsecurity.getYearOfAssessmentDetails().then(function () {
            //        if (PCSViewModel.appsecurity.isConfigurationFreeze() == 1) {
            //            PCSViewModel.appsecurity.WriteAccess(false);
            //        }
            //    })
            //})

            var parent = $(location).attr('href').split('/').pop();

            if (parent.split('?')[0] == 'PCSThresholds') {
                PCSViewModel.ComposeBindingFlag(false);
                invokepage();
                //$("#btnSaveThreshold").show();
            } else {
                $("#btnSaveThreshold").hide();
                $("#btnCancelThreshold").hide();
                $("#btnSaveThreshold1").hide();
                $("#btnCancelThreshold1").hide();
                PCSViewModel.ComposeBindingFlag(true);
                $('.modal').css('overflow', 'auto');
            }

            $(document).on('change', 'input', function (e) {
                var url = window.location.pathname;
                var filename = url.substring(url.lastIndexOf('/') + 1);
                if (filename == "PCSThresholds") {
                    Greyinput(e.currentTarget.id);
                }
            });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    };

    function invokepage() {
        try {
            var parent = $(location).attr('href').split('/').pop();

            if (parent.split('?')[0] == 'PCSThresholds') {
                PCSViewModel.ComposeBindingFlag(false);
            } else {
                PCSViewModel.ComposeBindingFlag(true);
                $('.modal').css('overflow', 'auto');
            }
            PCSViewModel.SurveyCategoryListTh([]);
            GetAllAssessmentTypes().then(function () {
                PCSViewModel.countEntry(0);
                PCSViewModel.FactorCountEntry(0);
                $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');
                GetSurveyCategoryTabs();
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: invokepage() method in InherentRiskHeatMap.js';
            logger.logMessage(msg);
        }
    }
    //function to pull all the assessment types starts here
    function GetAllAssessmentTypes() {
        try {
            return $.ajax({
                url: "/api/Configuration/GetAssessmentTypes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, error) {
                    PCSViewModel.AssessmentTypeList([]);
                    if (jsonResult != null) {


                        var MappedAssessmentList = $.map(jsonResult, function (result) {
                            return new AssessmentListModel(result);
                        });
                        PCSViewModel.AssessmentTypeList(MappedAssessmentList);
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(AMLQsViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }
    //function to pull al the asssesssment types ends here


    function GetSurveyCategoryTabs() {
        try {
            $.ajax({
                url: "/api/Configuration/GetSurveyCategoryTabsByAssessmentType",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "AssessmentId": PCSViewModel.SelectedAssessmentId(), "ScreenType": "PCS" }
            })
                .success(function (jsonResult, success) {
                    try {
                        if (jsonResult != null) {
                            if (jsonResult.length == 0) {
                                $('#loadingMainImgDivTh').hide();
                                $('#tabContent').hide();
                                $('#errorMainTab').show();
                            }
                            else {
                                var mappedTabList = $.map(jsonResult, function (result) {
                                    return new SurveyCategoryModel(result);
                                });
                                $('#loadingMainImgDivTh').show();
                                $('#tabContent').show();
                                PCSViewModel.SurveyCategoryListTh(mappedTabList);
                                $('#InherentTabDivTh').tabs();
                                $('#InherentTabDivTh').tabs('refresh');
                                $('#SurveyCategoryTabsDivTh').tabs({ active: 0 });
                                if (PCSViewModel.ComposeBindingFlag() == true) {
                                    $('.modal').css('overflow', 'auto');
                                }
                                $($('#SurveyCategoryTabsDivTh li').get(0)).trigger('click');
                                scrollableTabs();
                            }
                        }
                        else {
                            $('#loadingMainImgDivTh').hide();
                            $('#errorMainTab').show();
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in PCSThresholds.js';
                        logger.logMessage(msg);
                    }

                })
                .fail(function (error, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in PCSThresholds.js';
                        logger.logMessage(msg);
                    }

                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in PCSThresholds.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryTabClickTh(data, event) {
        try {
            $("#saveEditButtons").hide();
            $('#loadingMainImgDivTh').show();
            $('#FilterAreaAccordion').show();

            $('#SurveyCategoryTabsDivTh li').removeClass('active');
            $('#ParentTab_' + data.SurveyCategoryId()).addClass('active');

            PCSViewModel.SelectedSurveyComponentIdTh(data.SurveyCategoryId());
            //if (data.SurveyCategoryName() == 'Quantitative') {
            if (data.SurveyGroupShortName() == 'QTDR') {
                PCSViewModel.ClickedRiskAreaType('QTDR');
            }
            else {
                PCSViewModel.ClickedRiskAreaType('QLDR');
            }
            PCSViewModel.RiskAreaListTh([]);
            PCSViewModel.SurveyTypeClicked(data.SurveyGroupShortName());
            if (data.SurveyCategoryId() === 0)
                OverallTabClick(data, event);
            else
                //                GetAllRiskAreas();
                InitiateLevelTree();
            $('#loadingMainImgDivTh').hide();

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClickTh() method in PCSThresholds.js';
            logger.logMessage(msg);
        }
    }
    //--------------------------------------------------------------------draw threshold table--------------------------------------------------------------------------
    function Greyinput(id) {
        try {
            var z = $('#' + id).val();
            if (z == 100) {
                $('#' + id).addClass("grey");
                $('#' + id).removeClass("whiteinput");
            }
            else {
                $('#' + id).addClass("whiteinput");
                $('#' + id).removeClass("grey");
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Greyinput() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }
    function GreyOutCells() {
        try {
            for (var i = 1; i < PCSViewModel.ThresholdValuesList().length; i++) {
                var x = PCSViewModel.ThresholdValuesList()[i].IrlId()
                for (var j = 0; j < PCSViewModel.ThresholdChildList().length; j++) {
                    var y = PCSViewModel.ThresholdChildList()[j].RiskLevelId()
                    var z = $('#' + y + '_' + x).val()
                    if (z == 100) {
                        $('#' + y + '_' + x).addClass("grey");
                        $('#' + y + '_' + x).removeClass("whiteinput");
                    }
                    else {
                        $('#' + y + '_' + x).addClass("whiteinput");
                        $('#' + y + '_' + x).removeClass("grey");
                    }

                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GreyOutCells() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }
    function InputChange() {
        GreyOutCells();
        PCSViewModel.InputChangeEvent(true);
    }


    function GetAllRiskAreas() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllRiskAreas",
                data: { "AreaType": "NULL", "ParentAreaId": "NULL", "TypeId": "NULL", "SurveyCategoryID": PCSViewModel.SelectedSurveyComponentIdTh(), "AssessmentTypes": PCSViewModel.SelectedAssessmentId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in AMLThreshold.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult[0].RiskAreaName != null) {
                    var mappedRiskAreaListTh = $.map(jsonResult, function (result) {
                        return new RiskAreaModel(result);
                    });

                    PCSViewModel.RiskAreaListTh(mappedRiskAreaListTh);
                    PCSViewModel.countEntry(0);
                    $('#RaTabTh').tabs();
                    $('#RaTabTh').tabs('refresh');
                    $('#RaTabTh').tabs({ active: 0 });
                    if (PCSViewModel.ComposeBindingFlag() == true) {
                        $('.modal').css('overflow', 'auto');
                    }
                    $($('#RiskAreaUlTh li').get(0)).trigger('click');
                }
                else if (jsonResult[0].RiskAreaName == null)
                    app.showMessage("Risk Areas are not yet configured for this year of assessment. Please configure the Risk Areas to before setting Thresholds", "Error in Fetching Risk Areas", ["OK"])
                        .then(function (option) {
                            if (option == "OK")
                                router.navigate("configuration/RisksAreasfactors", true);
                        })
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(PCSViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in AMLThreshold.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        };
    }

    function GetAllRiskFactors() {
        try {
            PCSViewModel.PrevRAId(PCSViewModel.ClickedRiskAreaId());
            $.ajax({
                url: "/api/Configuration/GetAllRiskfactorAreaWise",
                data: { "RiskAreaId": PCSViewModel.ClickedRiskAreaId(), "AssessmentTypes": PCSViewModel.SelectedAssessmentId(), "SurveyCategoryID": PCSViewModel.SelectedSurveyComponentIdTh(), "ScreenType": "T" },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskFactors() method in AMLThreshold.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult.length == 0) {
                    $('#RiskAreaTabDivTh').hide();
                    $('#error').show();

                }
                else if (jsonResult != null && jsonResult[0].RiskFactorName != null) {
                    $('#error').hide();
                    var mappedRiskFactorListTh = $.map(jsonResult, function (result) {
                        return new RiskFactorModel(result);
                    });
                    PCSViewModel.RiskFactorListTh(mappedRiskFactorListTh);

                    $('#RfTabTh').tabs();
                    $('#RfTabTh').tabs('refresh');
                    $('#RfTabTh').tabs({ active: 0 });
                    $($('#RfTabTh li').get(0)).trigger('click');
                    scrollableTabs();
                }
                else if (jsonResult[0].RiskFactorName == null) {


                    app.showMessage("Risk Factors are not yet configured for this year of assessment. Please configure the Risk Factors to before setting Thresholds.", "Risk Factors not configured.", ["OK"])
                        .then(function (option) {
                            if (option == "OK")
                                router.navigate("configuration/RisksAreasfactors", true);
                        })

                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(PCSViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskFactors() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactors() method in AMLThreshold.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactors() method in AMLInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
    }

    function RiskAreaTabClickTh(data, event) {

        try {
            $('#lblThresholdValidation').hide();
            if (data.IsQualitative() == "0") {
                $('#QualitativeTabDivTh').hide();
                $('#loadingImgMainQualTh').hide();
                $('#RfTabTh').show();
                if (PCSViewModel.appsecurity.WriteAccess() == false || PCSViewModel.appsecurity.WriteAccess() == "false") {
                    PCSViewModel.countEntry(0);
                    PCSViewModel.FactorCountEntry(0);
                }
                if (PCSViewModel.countEntry() == 0) {
                    PCSViewModel.countEntry(1);
                    PCSViewModel.ClickedRiskAreaId(data.RiskAreaId());
                    PCSViewModel.ClickedRiskAreaName(data.RiskAreaName());
                    GetAllRiskFactors();
                }
                else if (PCSViewModel.InputChangeEvent() && PCSViewModel.SaveButtonClick() == false) {
                    PCSViewModel.InputChangeEvent(false);
                    app.showMessage("Please save the data before moving to other tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                        .then(function (option) {
                            if (option == "Save") {
                                $('#btnSaveThreshold').click();
                                PCSViewModel.countEntry(0);
                                PCSViewModel.FactorCountEntry(0);
                                if (PCSViewModel.ErrorStatus() == 1) {
                                    PCSViewModel.ErrorStatus(0);
                                    $('#' + PCSViewModel.PrevRAId()).addClass('ui-tabs-active ui-state-active');
                                    $('#' + data.RiskAreaId()).removeClass('ui-tabs-active ui-state-active');
                                }
                                else {
                                    PCSViewModel.SaveButtonClick(false);
                                    PCSViewModel.countEntry(0);
                                    $('#lblThresholdValidation').hide();
                                    $('#' + PCSViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                                    $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                                    RiskAreaTabClickTh(data, event);
                                }
                            }
                            else {
                                //PCSViewModel.WeightingsType('');
                                PCSViewModel.countEntry(1);
                                $('#lblThresholdValidation').hide();
                                PCSViewModel.FactorCountEntry(0);
                                $('#' + PCSViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                                $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                                PCSViewModel.ClickedRiskAreaId(data.RiskAreaId());
                                PCSViewModel.ClickedRiskAreaName(data.RiskAreaName());
                                GetAllRiskFactors();
                            }
                        })
                }
                else {
                    //PCSViewModel.SaveButtonClick(false);
                    PCSViewModel.InputChangeEvent(false);
                    PCSViewModel.countEntry(0);
                    $('#' + PCSViewModel.PrevRAId()).removeClass('ui-tabs-active ui-state-active');
                    $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
                    RiskAreaTabClickTh(data, event);
                }
            }
            else {
                if (data.IsQualitative() == "1")
                    $('#QualitativeTabDivTh').show();
                $('#loadingImgMainQualTh').show();
                $('#RfTabTh').hide();
                $('#qualfactordiv').hide();
                $("#saveEditButtons").hide();
                PCSViewModel.ClickedRiskAreaName(data.RiskAreaName());
                PCSViewModel.ClickedRiskAreaId(data.RiskAreaId());
                PCSViewModel.ClickedRiskAreaType(data.RiskAreaType());
                GetQualThresholdData(PCSViewModel.ClickedRiskAreaId());
            }
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClickTh() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

    function RiskFactorTabClickTh(data, event) {
        try {
            $('#QualitativeTabDivTh').hide();
            if (PCSViewModel.appsecurity.WriteAccess() == false || PCSViewModel.appsecurity.WriteAccess() == "false") {
                PCSViewModel.FactorCountEntry(0);
            }
            if (data.RiskAreaId() === data.RiskFactorId()) {
                $('#QualitativeTabDivTh').show();
                $('#RiskFactorTabDivTh').hide();
                $('#loadingImgMainQualTh').hide();
                GetQualThresholdData(data.RiskAreaId());
                return false;
            }
            if (PCSViewModel.FactorCountEntry() == 0) {
                PCSViewModel.FactorCountEntry(1);
                $('#loadingImgMainTh').show();
                $('#FactorDataDivTh').hide();
                $('#lblThresholdValidation').hide();
                PCSViewModel.ClickedRiskFactorId(data.RiskFactorId());
                PCSViewModel.ClickedRiskFactorName(data.RiskFactorName());
                PCSViewModel.ClickedRAType(data.RA_Type());
                $('#FAC_' + PCSViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                GetThresholdData();
            }
            else if (PCSViewModel.InputChangeEvent() && PCSViewModel.SaveButtonClick() == false) {
                PCSViewModel.InputChangeEvent(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                    .then(function (option) {
                        if (option == "Save") {
                            $('#btnSaveThreshold').click();
                            PCSViewModel.FactorCountEntry(0);
                            if (PCSViewModel.ErrorStatus() == 1) {
                                PCSViewModel.ErrorStatus(0);
                                $('#FAC_' + PCSViewModel.PrevFactorId()).addClass('ui-tabs-active ui-state-active');
                                $('#FAC_' + data.RiskFactorId()).removeClass('ui-tabs-active ui-state-active');
                            }
                            else {
                                PCSViewModel.SaveButtonClick(false);
                                PCSViewModel.FactorCountEntry(0);
                                $('#FAC_' + PCSViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                                $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                                RiskFactorTabClickTh(data, event);
                            }
                        }
                        else {
                            //PCSViewModel.WeightingsType('');
                            PCSViewModel.FactorCountEntry(1);
                            $('#lblThresholdValidation').hide();
                            $('#FAC_' + PCSViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                            $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                            $('#loadingImgMainTh').show();
                            $('#FactorDataDivTh').hide();
                            PCSViewModel.ClickedRiskFactorId(data.RiskFactorId());
                            PCSViewModel.ClickedRiskFactorName(data.RiskFactorName());
                            PCSViewModel.ClickedRAType(data.RA_Type());
                            GetThresholdData();
                        }
                    })
            }
            else {
                PCSViewModel.InputChangeEvent(false);
                PCSViewModel.SaveButtonClick(false);
                PCSViewModel.FactorCountEntry(0);
                $('#FAC_' + PCSViewModel.PrevFactorId()).removeClass('ui-tabs-active ui-state-active');
                $('#FAC_' + data.RiskFactorId()).addClass('ui-tabs-active ui-state-active');
                RiskFactorTabClickTh(data, event);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorTabClickTh() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

    function OverallTabClick(data, event) {
        try {
            //$('#QualitativeTabDivTh').show();
            $('#loadingImgMainQualTh').show();

            $('#RfTabTh').hide();
            $('#FilterAreaAccordion').hide();
            $("#saveEditButtons").hide();
            $('#overalldiv').hide();
            GetOverallThresholdData();
            //$("#loadingImgMainQualTh").hide();
            //$("#saveEditButtons").show();

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OverallTabClick() method in PCSThresholds.js';
            logger.logMessage(msg);
        }
    }

    function GetThresholdData() {
        try {
            PCSViewModel.PrevFactorId(PCSViewModel.ClickedRiskFactorId());
            $.ajax({
                url: "/api/WeightingsThresholds/GetFactorThreshold?TableId=" + PCSViewModel.ClickedRiskFactorId() + "&AssessmentType=" + PCSViewModel.SelectedAssessmentId() +
                    "&TableType=" + PCSViewModel.ClickedRAType() + "&SurveyCategoryId=" + PCSViewModel.SelectedSurveyComponentIdTh(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetThresholdData() method in AMLThreshold.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 0 || jsonResult == null) {
                    $('#loadingImgMainTh').hide();
                    $('#FactorDataDivTh').show();
                    $('#NoDataErrorThresholds').show();
                }
                else {
                    $('#NoDataErrorThresholds').hide();
                    $('#loadingImgMainTh').hide();
                    $('#FactorDataDivTh').show();
                    var MappedThresholdValue = $.map(jsonResult, function (result) {
                        return new ThresholdValueModel(result);
                    });
                    $('#tblThreshold tbody tr').remove();
                    PCSViewModel.ThresholdValuesList(MappedThresholdValue);

                    var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                        return new ThresholdValueModel(result);
                    });
                    PCSViewModel.ThresholdValuesListDup(MappedThresholdValueDup);

                    PCSViewModel.ThresholdChildList(PCSViewModel.ThresholdValuesList()[0].ChildList());
                    GreyOutCells();

                    if (PCSViewModel.ComposeBindingFlag()) {
                        $("#btnSaveThreshold").hide();
                        $("#btnCancelThreshold").hide();
                        $("#btnSaveThreshold1").hide();
                        $("#btnCancelThreshold1").hide();

                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetThresholdData() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetThresholdData() method in AMLThreshold.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetThresholdData() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        }
    }

    function ThresholdCellBlur(data, event) {
        try {
            var RiskLevelId = event.currentTarget.parentNode.parentNode.id;
            var Value = event.currentTarget.value;
            ValidateThresholdValues(data.IrlId(), RiskLevelId, Value);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ThresholdCellBlur() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

    function ValidateThresholdValues(IrlId, RiskLevelId, Value) {
        try {
            var Result = false;
            var ColumnIndex = 0;
            var RowIndex = 0;
            for (var i = 0; i < $('#tblThreshold thead tr th').length; i++) {
                if ($('#tblThreshold thead tr th').get(i).id == IrlId)
                    ColumnIndex = i;
            }
            ColumnIndex = (ColumnIndex * 2) + 1;
            for (var i = 0; i < $('#tblThreshold tbody tr').length; i++) {
                if ($($('#tblThreshold tbody tr').get(i)).find('td').get(ColumnIndex).id == RiskLevelId)
                    RowIndex = i;
            }
            var ErrorMsg = "";

            if (Value == "" || Value == undefined) {
                ErrorMsg = "Value cannot be left blank";
                $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
            }
            else if (isNaN(Value)) {
                ErrorMsg = "Non-Numeric Value is not allowed";
                $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
            }
            else if (Value < 0 || Value > 100) {
                ErrorMsg = "Value should be in range 0 - 100";
                $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
            }
            else {
                if ((parseFloat(Value).toString().indexOf('.') < 0) ? true : ((parseFloat(Value).toString().split('.')[1].length <= 2) ? true : false)) {
                    $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').removeAttr('style');
                    ErrorMsg = "";
                    Result = true;
                }
                else {
                    ErrorMsg = "Decimal Upto Only 2 Places is Allowed";
                    $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('input').css("border", "1px solid red");
                }
            }
            if (ErrorMsg.length > 0) {
                PCSViewModel.ErrorStatus(1);
            }
            $($($('#tblThreshold tbody tr').get(RowIndex)).find('td').get(ColumnIndex)).find('label').text(ErrorMsg);
            return Result;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ValidateThresholdValues() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

    function ConvertObservableToObject(Data) {
        try {
            var ThresholdValue = new Array();
            for (var i = 0; i < Data().length; i++) {
                var Child = new Array();
                for (j = 0; j < Data()[i].ChildList().length; j++) {
                    Child.push(new Object({
                        RiskLevelId: Data()[i].ChildList()[j].RiskLevelId(),
                        RiskLevelName: Data()[i].ChildList()[j].RiskLevelName(),
                        RiskLevelCss: Data()[i].ChildList()[j].RiskLevelCss()
                    }));
                }
                ThresholdValue.push(new Object({
                    IrlId: Data()[i].IrlId(),
                    IrlName: Data()[i].IrlName(),
                    Child: Child
                }));
            }
            return ThresholdValue;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ConvertObservableToObject() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

    function ResetThresholdData() {
        try {
            for (var i = 1; i < PCSViewModel.ThresholdValuesListDup().length; i++) {
                for (var j = 0; j < PCSViewModel.ThresholdValuesListDup()[i].ChildList().length; j++) {
                    var Value = PCSViewModel.ThresholdValuesListDup()[i].ChildList()[j].RiskLevelName();
                    PCSViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName(Value);
                }
            }
            $('#tblThreshold tbody input').removeAttr('style');
            $('#tblThreshold tbody #lblValidation').text("");
            $('#lblThresholdValidation').text("");
            $('#lblThresholdValidation').hide();
            GreyOutCells();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ResetThresholdData() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

    function SaveThresholdBtnClick() {
        try {
            PCSViewModel.SaveButtonClick(true);
            var Counter = 0;
            for (var i = 1; i < PCSViewModel.ThresholdValuesList().length; i++) {
                for (var j = 0; j < PCSViewModel.ThresholdValuesList()[i].ChildList().length; j++) {
                    if (!(ValidateThresholdValues(PCSViewModel.ThresholdValuesList()[i].IrlId(), PCSViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelId(), PCSViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName())))
                        Counter++;
                }
            }
            if (Counter == 0) {
                $('#lblThresholdValidation').text("");
                $('#lblThresholdValidation').hide();
                var ObjectData = ConvertObservableToObject(PCSViewModel.ThresholdValuesList);
                SaveThresholdValues(ObjectData);
            }
            else {
                $('#lblThresholdValidation').text("Please correct the errors highlighted in below cells before saving the Threshold Data.");
                $('#lblThresholdValidation').show();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveThresholdBtnClick() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

    function SaveThresholdValues(ObjectData) {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/WeightingsThresholds/saveFactorThreshold?TableId=" + PCSViewModel.ClickedRiskFactorId() + "&AssessmentType=" + PCSViewModel.SelectedAssessmentId() +
                    "&TableType=F&SurveyCategoryId=" + PCSViewModel.SelectedSurveyComponentIdTh() + "&copyFlag=" + PCSViewModel.copyToAllFlag(),
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(ObjectData)
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveThresholdValues() method in AMLThreshold.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                PCSViewModel.copyToAllFlag(0);
                if (jsonResult == 1) {
                    for (var i = 1; i < PCSViewModel.ThresholdValuesList().length; i++) {
                        for (var j = 0; j < PCSViewModel.ThresholdValuesList()[i].ChildList().length; j++) {
                            var Value = PCSViewModel.ThresholdValuesList()[i].ChildList()[j].RiskLevelName();
                            PCSViewModel.ThresholdValuesListDup()[i].ChildList()[j].RiskLevelName(Value);
                        }
                    }
                    logger.logSuccess('Threshold Data saved successfully.', 'Success', system.getModuleId(PCSViewModel), true);
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(PCSViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveThresholdValues() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                PCSViewModel.copyToAllFlag(0);
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveThresholdValues() method in AMLThreshold.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in SaveThresholdValues() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        }
    }

    //-------------------------------------------------------------Model Definition Starts Here-----------------------------------------------------------------------
    function RiskAreaModel(item) {
        try {

            var self = this;
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            self.RiskAreaNotes = ko.observable($('<div/>').html(item.RiskAreaNotes).text());
            self.TargetRow = ko.observable();
            self.IsQualitative = ko.observable(item.IsQualitative);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    };

    function RiskFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    };

    function ThresholdValueModel(item) {
        try {
            var self = this;
            self.IrlId = ko.observable(item.IrlId);
            self.IrlName = ko.observable(item.IrlName);
            var MappedChild = $.map(item.Child, function (result) {
                return new ThresholdChildModel(result);
            });
            self.ChildList = ko.observableArray(MappedChild);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ThresholdValueModel() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

    function ThresholdChildModel(item) {
        try {
            var self = this;
            self.RiskLevelId = ko.observable(item.RiskLevelId);
            self.RiskLevelName = ko.observable(item.RiskLevelName);
            self.RiskLevelCss = ko.observable(item.RiskLevelCss);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ThresholdChildModel() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }
    function CRSDataModel(item) {
        try {

            var self = this;
            self.Min = ko.observable(item.Min);
            self.Max = ko.observable(item.Max);
            self.Comments = ko.observable($('<div/>').html(item.Comments).text());
            self.Id = ko.observable(item.Id);
            self.Description = ko.observable($('<div/>').html(item.Description).text());
            self.CSS = ko.observable($('<div/>').html(item.CSS).text());

            if (RlViewModel.AddNewLevelCount() == -1) {
                self.Flag = ko.observable('');
            }
            else {
                self.Flag = ko.observable(item.Flag);
            }
            var ImagePath = self.CSS() + '.png';
            var CompletePath = '../../../Content/images/';

            self.imagePath = ko.observable((CompletePath).concat(ImagePath));

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSDataModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryModel(item) {
        try {
            var self = this;
            self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
            self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
            self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
            self.SurveyType = ko.observable(item.SurveyType);
            self.Applicability = ko.observable(item.Applicability);
            self.SurveyGroupId = ko.observable(item.SurveyGroupId);
            self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
            self.IsEditable = ko.observable(item.IsEditable);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
            self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in PCSThresholds.js';
            logger.logMessage(msg);
        }
    }
    //-------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------

    function ValidateThresholdsValues(data) {
        var validation = true;
        if (PCSViewModel.SelectedSurveyComponentIdTh() === 0) {
            $.each(PCSViewModel.OverallThresholdValuesList(), function (index, value) {
                var level = value.Level();
                if (parseFloat(value.Min()) >= parseFloat(value.Max())) {
                    value.ShouldShowMessage(true);
                    value.ValidationMessage("Max should be more then Min");
                    validation = false;
                }
                else if (value.ShouldShowMessage()) {
                    value.ShouldShowMessage(false);
                    value.ValidationMessage(null);
                    validation = true;
                }
            });
        }
        else {
            $.each(PCSViewModel.QualThresholdValuesList(), function (index, value) {
                var level = value.Level();
                if (parseFloat(value.Min()) >= parseFloat(value.Max())) {
                    value.ShouldShowMessage(true);
                    value.ValidationMessage("Max should be more then Min");
                    validation = false;
                }
                else if (value.ShouldShowMessage()) {
                    value.ShouldShowMessage(false);
                    value.ValidationMessage(null);
                    validation = true;
                }
            });
        }
        return validation;
    }

    function SaveQualitativeThresholdValues(data) {
        try {
            var jsonString = "";
            var copyFlag = PCSViewModel.copyToAllFlag();
            var TableId = PCSViewModel.ClickedRiskAreaId();

            var ValidFlag = 1;

            for (var i = 0; i < PCSViewModel.QualThresholdValuesList().length; i++) {
                if (PCSViewModel.QualThresholdValuesList()[i].Max() == '') {
                    ValidFlag = 0;
                }
            }

            if (ValidFlag == 1) {


                var TableType = "";
                if (PCSViewModel.SelectedSurveyComponentIdTh() === 0) {
                    jsonString = $.map(PCSViewModel.OverallThresholdValuesList(), function (result) {
                        return {
                            Uid: result.Uid(),
                            FinalRiskId: result.FinalRiskId(),
                            Min: result.Min(),
                            Max: result.Max(),
                            Description: result.Description(),
                            Level: result.Level(),
                            Css: result.CSS()
                        }
                    });
                    TableId = 0;
                    TableType = "B";
                }
                else {
                    jsonString = $.map(PCSViewModel.QualThresholdValuesList(), function (result) {
                        return {
                            Uid: result.Uid(),
                            FinalRiskId: result.FinalRiskId(),
                            Min: result.Min(),
                            Max: result.Max(),
                            Description: result.Description(),
                            Level: result.Level(),
                            Css: result.CSS()
                        }
                    });
                    TableType = "A";
                }

                if (ValidateThresholdsValues(data)) {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/saveFactorThreshold?TableId=" + TableId + "&AssessmentType=" + PCSViewModel.SelectedAssessmentId() +
                            "&TableType=PCS&SurveyCategoryId=" + PCSViewModel.SelectedSurveyComponentIdTh() + "&CopyFlag=" + copyFlag,
                        headers: headers,
                        traditional: true,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(jsonString)
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
            }
            else {
                GetQualThresholdData(PCSViewModel.ClickedRiskAreaId());
                logger.logError('Please enter valid Numeric Values.', 'Error', system.getModuleId(PCSViewModel), true);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveQualitativeThresholdValues() method in AMLThreshold.js';
            logger.logMessage(msg);
        }


        function ajaxSuccess(jsonResult, status) {
            try {
                PCSViewModel.copyToAllFlag(0);
                if (jsonResult == 1) {
                    if (PCSViewModel.SelectedSurveyComponentIdTh() === 0)
                        GetOverallThresholdData();
                    else
                        GetQualThresholdData(PCSViewModel.ClickedRiskAreaId());
                    logger.logSuccess('Qualitative Threshold Data saved successfully.', 'Success', system.getModuleId(PCSViewModel), true);

                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', true);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveQualitativeThresholdValues() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                PCSViewModel.copyToAllFlag(0);
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveQualitativeThresholdValues() method in AMLThreshold.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in SaveQualitativeThresholdValues() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetQualThresholdData(data) {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/GetQualFactorThreshold",
                data: {
                    "TableId": parseInt(data), "AssessmentType": PCSViewModel.SelectedAssessmentId(), "TableType": "PCS", "SurveyCategoryId": PCSViewModel.SelectedSurveyComponentIdTh()
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQualThresholdData() method in AMLThreshold.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 0 || jsonResult == null) {
                    $('#loadingImgMainQualTh').hide();
                    $('#qualfactordiv').show();
                    $("#saveEditButtons").show();
                    $('#NoDataErrorQualThresholds').show();
                }
                else {
                    $('#NoDataErrorQualThresholds').hide();
                    $("#error").hide();
                    $('#loadingImgMainQualTh').hide();
                    $('#qualfactordiv').show();
                    $("#saveEditButtons").show();
                    var MappedQualThresholdValue = $.map(jsonResult, function (result) {
                        return new QualThresholdValueModel(result);
                    });
                    $('#tblThreshold tbody tr').remove();
                    PCSViewModel.QualThresholdValuesList(MappedQualThresholdValue);

                    var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                        return new QualThresholdValueModel(result);
                    });
                    PCSViewModel.QualThresholdValuesListDup(MappedThresholdValueDup);
                    if (PCSViewModel.ComposeBindingFlag()) {
                        $("#btnSaveThreshold").hide();
                        $("#btnCancelThreshold").hide();
                        $("#btnSaveThreshold1").hide();
                        $("#btnCancelThreshold1").hide();

                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQualThresholdData() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQualThresholdData() method in AMLThreshold.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetQualThresholdData() method in AMLThreshold.js';
                logger.logMessage(msg);
            }
        }
    }

    function copyToAll(data, event) {
        try {
            //$('#CopyToAllPopup').modal('show');
            app.showMessage('Are you sure you want to Copy Thrsholds to all Levels, It will clear all previously saved values?', 'Apply Changes', ['Confirm', 'Cancel'], false, { primaryButtonClass: "mr-2 btn-curved fa fa-check btn btn-success autofocus", secondaryButtonClass: "mr-2 btn-curved fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-edit text-default' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        console.log(PCSViewModel.ClickedRiskAreaType());
                        PCSViewModel.copyToAllFlag(1);
                        if (PCSViewModel.ClickedRiskAreaType() === 'QLDR') {
                            // CALL THE QUALITTATIVE SAVE WITH FLAG = 1
                            SaveQualitativeThresholdValues();

                        }
                        else {
                            SaveThresholdBtnClick();
                            // CALL THE QUANTITATIVE SAVE WITH FLAG = 0
                        }

                        //(data, event);
                        //alert('Hello Message');
                        //OrgLevelChangeClick();
                        //we will use the save function with an additional flag
                    }
                });
        }
        catch (e) {
            let msg = 'Exception: ' + e + ' | Source: copyToAll() method in PCSThresholds.js';
            logger.logMessage(msg);
        }
    }

    function GetOverallThresholdData() {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/GetOverallThresholdData",
                data: {
                    "TableId": 0, "AssessmentType": PCSViewModel.SelectedAssessmentId(), "TableType": "PCS", "SurveyCategoryId": PCSViewModel.SelectedSurveyComponentIdTh()
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetOverallThresholdData() method in PCSThresholds.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 0 || jsonResult == null) {
                    $('#loadingImgMainQualTh').hide();
                    $('#overalldiv').show();
                    $("#saveEditButtons").show();
                    $('#NoDataErrorOverallThresholds').show();
                }
                else {
                    $('#NoDataErrorOverallThresholds').hide();
                    $("#error").hide();
                    $('#loadingImgMainQualTh').hide();
                    $('#overalldiv').show();
                    $("#saveEditButtons").show();
                    var MappedQualThresholdValue = $.map(jsonResult, function (result) {
                        return new QualThresholdValueModel(result);
                    });
                    $('#tblThreshold tbody tr').remove();
                    PCSViewModel.OverallThresholdValuesList(MappedQualThresholdValue);

                    var MappedThresholdValueDup = $.map(jsonResult, function (result) {
                        return new QualThresholdValueModel(result);
                    });
                    PCSViewModel.OverallThresholdValuesListDup(MappedThresholdValueDup);
                    if (PCSViewModel.ComposeBindingFlag()) {
                        $("#btnSaveThreshold").hide();
                        $("#btnCancelThreshold").hide();
                        $("#btnSaveThreshold1").hide();
                        $("#btnCancelThreshold1").hide();

                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetOverallThresholdData() method in PCSThresholds.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetOverallThresholdData() method in PCSThresholds.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetOverallThresholdData() method in PCSThresholds.js';
                logger.logMessage(msg);
            }
        }
    }

    function ResetQualitativeThresholdValues(data) {
        try {
            if (PCSViewModel.SelectedSurveyComponentIdTh() === 0) {
                for (var i = 0; i < PCSViewModel.OverallThresholdValuesList().length; i++) {
                    var valuemax = PCSViewModel.OverallThresholdValuesList()[i].Max();
                    var valuemin = PCSViewModel.OverallThresholdValuesList()[i].Min();
                    PCSViewModel.OverallThresholdValuesList()[i].Min(valuemin);
                    PCSViewModel.OverallThresholdValuesList()[i].Max(valuemax);
                    PCSViewModel.OverallThresholdValuesList()[i].ValidationMessage("");
                }
            }
            else {
                for (var i = 0; i < PCSViewModel.QualThresholdValuesList().length; i++) {
                    var valuemax = PCSViewModel.QualThresholdValuesListDup()[i].Max();
                    var valuemin = PCSViewModel.QualThresholdValuesListDup()[i].Min();
                    PCSViewModel.QualThresholdValuesList()[i].Min(valuemin);
                    PCSViewModel.QualThresholdValuesList()[i].Max(valuemax);
                    PCSViewModel.QualThresholdValuesList()[i].ValidationMessage("");
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail  in ResetQualitativeThresholdValues() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

    function onKeyPressvalidateNumber(data, event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode != 46 && charCode > 31 && charCode != 45
            && (charCode < 48 || charCode > 57))
            return false;
        return true;

    }

    function InherentQualDataToggle(data, event) {
        try {
            // $("#loadingMainImgDivAMLRA").show();
            if ($("#SubfactordataQual").is(':checked')) {
                AMLRaViewModel.RiskFactorFlagQual(true);
            }
            else {
                AMLRaViewModel.RiskFactorFlagQual(false);
            }
            //GetAllQualitativeData();
        }
        catch (e) {
            var msg = 'exception' + e + ' InherentQualDataToggle() in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function onBlurMin(data) {
        var level = data.Level() - 1;
        if ($.isNumeric(data.Min())) {
            if (PCSViewModel.SelectedSurveyComponentIdTh() === 0) {
                for (var i = 0; i < PCSViewModel.OverallThresholdValuesList().length; i++) {
                    var comp = PCSViewModel.OverallThresholdValuesList()[i];
                    if (comp.Level() == (level)) {
                        if (Number(data.Min()) < Number(comp.Max())) {
                            data.ShouldShowMessageMin(true);
                            data.ValidationMessageMin("Minimum Threshold should be more then Maximum Threshold of previous level");
                            return;
                        }

                    }
                }

            }
            else {
                for (var i = 0; i < PCSViewModel.QualThresholdValuesList().length; i++) {
                    var comp = PCSViewModel.QualThresholdValuesList()[i];
                    if (comp.Level() == (level)) {
                        if (Number(data.Min()) < Number(comp.Max())) {
                            data.ShouldShowMessageMin(true);
                            data.ValidationMessageMin("Minimum Threshold should be more then Maximum Threshold of previous level");
                            return;
                        }

                    }
                }
            }
            if (Number(data.Min()) >= Number(data.Max())) {
                data.ShouldShowMessageMin(true);
                data.ValidationMessageMin("Minimum Threshold should be less then Maximum Threshold");
                return;
            }

        }
        else {
            data.ShouldShowMessageMin(true);
            data.ValidationMessageMin("Non numeric values are not allowed");
            return;
        }
        data.ShouldShowMessageMin(false);
        data.ValidationMessageMin("");
    }

    function onBlurEvent(data) {
        var level = data.Level();
        if ($.isNumeric(data.Max())) {
            if (Number(data.Min()) >= Number(data.Max())) {
                data.ShouldShowMessage(true);
                data.ValidationMessage("Max should be more then Min");
            }
            else {
                data.ShouldShowMessage(false);
                data.ValidationMessage(null);
                if (PCSViewModel.SelectedSurveyComponentIdTh() === 0) {
                    $.each(PCSViewModel.OverallThresholdValuesList(), function (index, value) {
                        if (value.Level() == (level + 1)) {
                            var splitstr = (data.Max().toString().indexOf('.') > 0) ? data.Max().split('.') : data.Max();
                            var count = 0;
                            if (splitstr.length > 1)
                                count = splitstr[1].length;
                            else
                                count = splitstr.length;

                            var num = Math.pow(10, -count);
                            value.Min(parseFloat(parseFloat(data.Max()) + parseFloat(num)).toFixed(count));
                            //  value.Min(parseFloat(parseFloat(data.Max()) + 0.01).toFixed(2));
                        }
                    });
                }
                else {
                    $.each(PCSViewModel.QualThresholdValuesList(), function (index, value) {
                        if (value.Level() == (level + 1)) {
                            var splitstr = (data.Max().toString().indexOf('.') > 0) ? data.Max().split('.') : data.Max();
                            var count = 0;
                            if (splitstr.length > 1)
                                count = splitstr[1].length;
                            else
                                count = splitstr.length;


                            var num = Math.pow(10, -count);
                            value.Min(parseFloat(parseFloat(data.Max()) + parseFloat(num)).toFixed(count));
                            //value.Min(parseFloat(parseFloat(data.Max()) + 0.01).toFixed(2));
                        }
                    });
                }
            }
        }
        else {
            data.ShouldShowMessage(true);
            data.ValidationMessage("Non numeric values are not allowed");
        }
        data.ShouldShowMessageMin(false);
        data.ValidationMessageMin("");
    }
    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }
    function QualThresholdValueModel(item) {
        try {

            var self = this;
            self.Uid = ko.observable(item.Uid);
            self.FinalRiskId = ko.observable(item.FinalRiskId);
            self.Min = ko.observable(item.Min);
            self.Max = ko.observable(item.Max);
            self.ValidationMessage = ko.observable(null);
            self.ShouldShowMessage = ko.observable(false);
            self.ValidationMessageMin = ko.observable(null);
            self.ShouldShowMessageMin = ko.observable(false);
            self.onBlur = function (data) {
                onBlurEvent(data);
            };
            self.Description = ko.observable($('<div/>').html(item.Description).text());
            //self.CSS = ko.observable($('<div/>').html(item.CSS).text());
            self.CSS = ko.observable(item.Css);
            self.Level = ko.observable(item.Level);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualThresholdValueModel() method in AMLThreshold.js';
            logger.logMessage(msg);
        }
    }

    function ToggleNavigationMenu1() {
        var chk2 = $('#NavigationToggle2');
        chk2.prop("checked", false);
        $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
        $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
        $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
        $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
        $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
        $("#divNavSwitch2").show();
        $("#divjsTree").hide();
    }

    function CollapseAllTreeView() {
        if ($('#spanExpandAll').text() == "Expand") {
            $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
            $("#spanExpandAll").text("Collapse");
            $("#arrowSpan").removeClass("fa-caret-right").addClass("fa-caret-down");
        }
        else {
            $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
            $("#spanExpandAll").text("Expand");
            $("#arrowSpan").removeClass("fa-caret-down").addClass("fa-caret-right");

        }
       
    }

    function ToggleNavigationMenu2() {
        var chk1 = $('#NavigationToggle1');
        chk1.prop("checked", true);
        $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
        $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
        $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
        $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
        $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
        $("#divNavSwitch2").hide();
        $("#divjsTree").show();
    }

    function ExpandAllTreeView() {
        $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
    }
    function SearchTreeView() {
        $('#jsTreeAreaLevel').treeview('search', ['Parent', {
            ignoreCase: true,
            exactMatch: false,
            revealResults: true,
        }]);
    }


    function InitiateLevelTree() {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            getJsTreeAreaLevel = {

                url: "/api/RiskRatingConfiguration/GetAllAreasForRR",
                type: "GET",
                headers: headers
            };
            $.ajax(getJsTreeAreaLevel)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in SurveyResponsePage.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            if (jsonResult != null) {
                if (jsonResult.AreaLevelsData["#"] == undefined) {
                    $('#riskFactorsTable').hide();
                    $('#FilterAreaAccordion').hide();
                
                    $('#error').show();

                }
                else {
                    //implement js tree logic here
                    PCSViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);

                    var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                        return new jsTreeModel(result);
                    });

                    $('#jsTreeAreaLevel').treeview({
                        data: MappedJsTreeList,
                        onNodeSelected: nodeClickEvent
                    });

                    var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                    PCSViewModel.hasChildNodes(hasChildNodes);

                    //for initial load expand for treeview

                    //$("#ExpandAll").trigger("click");
                    //$("#ExpandAll").trigger("click");
                    $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                    $("loadingImgOrCalc").hide();
                    $("loadingMainImgDivTh").hide();
                    $("loadingImgMainTh").hide();
                }
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in PCSThresholds.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in PCSThresholds.js';
                logger.logMessage(msg);
            }
        }

        function filterJsTree(TreeStructure) {

            return TreeStructure.filter(
                function (item) {
                    if (item.nodes != undefined && item.nodes.length > 0) {
                        item.nodes = filterJsTree(item.nodes);
                    }

                    if (item.showLevel == 1)
                        return true;
                    else
                        return false;

                }
            );
        }


        function nodeClickEvent(event, node) {

            if (node.dead_node == 1) {
                //select node explicitly in case of recursive calling activity.
                $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);

                PCSViewModel.ClickedRiskFactorId(node.id);
                $('#DynamicHTMLDiv').html("");
                $('#QualContDynamicHTMLDiv').html("");
                $('#loadingImgMain').modal('show');
                PCSViewModel.copyToAllFlag(0);
                $('#lblThresholdValidation').hide();
                PCSViewModel.ClickedRiskAreaId(parseInt(node.id));
                PCSViewModel.ClickedRiskFactorName($('<div/>').html(node.text).text());
                PCSViewModel.ClickedRAType(node.RA_Type());
                if (PCSViewModel.ClickedRiskAreaType() == 'QLDR' && PCSViewModel.ClickedRAType() == 'F') {
                    $('#QualitativeTabDivTh').show();
                    $('#loadingImgMainQualTh').show();
                    $('#RfTabTh').hide();
                    $('#qualfactordiv').hide();
                    $("#saveEditButtons").hide();

                    PCSViewModel.ClickedRiskAreaName($('<div/>').html(node.text).text());

                    GetQualThresholdData(PCSViewModel.ClickedRiskAreaId());

                }
            }
                else {
                //recursively opening until the dead_node arrives.
                if (!(node.state.expanded))
                    nodeClickEvent(event, node.nodes[0]);
                $('#jsTreeAreaLevel').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                $('#jsTreeAreaLevel').treeview('unselectNode', [node.nodeId, { silent: true }]);


                   }
          
            }

            


            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }

        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (PCSViewModel.AreaLeveljstree()[self.id].length > 0) {
                self.nodes = $.map(PCSViewModel.AreaLeveljstree()[self.id], function (result) {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: false };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);

        }
    


});
